<template>
  <div>
    <div class="d-flex row wrapper border-bottom white-bg page-heading justify-content-between">
      <div class="col-6 col-md-6">
        <h2 class="mt-1">{{ $t("navigations.dashboard") }}</h2>
      </div>
    </div>

    <div class="wrapper wrapper-content px-0">
      <!-- KPI SECTION -->
      <div class="kpi-container ">
        <div class="kpi card mb-1">
          <h3>Planned Enrollment</h3>
          <p>{{ kpis.totalPlanned }}</p>
        </div>
        <div class="kpi card mb-1">
          <h3>Actual Enrollment</h3>
          <p>{{ kpis.totalActual }}</p>
        </div>
        <div class="kpi card mb-1">
          <h3>Enrollment %</h3>
          <p>{{ enrollmentPercent }}%</p>
        </div>
        <div class="kpi card mb-1">
          <h3>Active Sites</h3>
          <p>{{ kpis.activeSites }}</p>
        </div>
      </div>

      <div class="row">
        <!-- Site Summary -->
        <div class="col-lg-6 pr-0 pl-1 mb-1">
          <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between py-1">
              <h5 class="mt-2">{{ $t("navigations.site summary") }}</h5>
            </div>

            <div class="ibox-content graphminheight">
              <div v-if="summaryLoading" class="chart-loader">
                <div class="spinner-border" role="status" aria-label="Loading"></div>
                <div class="loader-text">Loading...</div>
              </div>

              <div v-show="!summaryLoading">
                <apexchart
                  width="100%"
                  height="250px"
                  :key="summaryChartKey"
                  type="bar"
                  :options="summarychart.chartOptions"
                  :series="summarychart.dataseries"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Subject Summary (Pie Only) -->
        <div class="col-lg-6 pr-0 pl-1 mb-1">
          <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between py-1">
              <h5 class="mt-2">{{ $t("navigations.subject summary") }}</h5>
            </div>

            <div class="ibox-content graphminheight" ref="patientWrap">
              <apexchart
                v-if="hasPatientPieData"
                width="100%"
                height="250px"
                type="pie"
                :options="patientchart.piechartOptions"
                :series="patientchart.piedataseries"
              />
              <div v-else class="p-2">No data</div>
            </div>
          </div>
        </div>

        <!-- SITE LEVEL: Planned vs Actual (own dropdown + own loading) -->
        <div class="col-lg-6 pr-0 pl-1 mb-1">
          <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between py-1">
              <h5 class="mt-2">Site Level: Planned vs Actual</h5>
              
            </div>

            <div class="ibox-content graphminheight2">
              <div v-if="siteLevelLoading" class="chart-loader">
                <div class="spinner-border" role="status" aria-label="Loading"></div>
                <div class="loader-text">Loading...</div>
              </div>

              <div v-show="!siteLevelLoading">
                <apexchart
                  type="bar"
                  height="360"
                  width="100%"
                  :options="siteLevelChartOptions"
                  :series="siteLevelChartSeries"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- SITE + DATE RANGE (own dropdown + own loading) -->
        <div class="col-lg-6 pr-0 pl-1 mb-1">
          <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between py-1">
              <h5 class="mt-2">Site Enrollment by Date Range</h5>
              <select v-model="commonSiteId">
                  <option v-for="s in sites" :key="s.siteCode" :value="s.siteID">
                    {{ s.siteCode }}
                  </option>
                </select>
            </div>

            <div class="ibox-content graphminheight2">
              <div v-if="dateRangeLoading" class="chart-loader">
                <div class="spinner-border" role="status" aria-label="Loading"></div>
                <div class="loader-text">Loading...</div>
              </div>

              <div v-show="!dateRangeLoading">
                <div v-if="!(dateRangeData && dateRangeData.categories && dateRangeData.categories.length)" class="p-2">
                  No schedule data
                </div>
                <apexchart
                v-else
                  type="line"
                  height="340"
                  width="100%"
                  :options="dateRangeChartOptions"
                  :series="dateRangeChartSeries"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- end row -->
      </div>
    </div>
  </div>
</template>

<script src="./CRA_summary.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";

.ibox-body {
  background-color: #ffffff;
  margin: 3rem, 0;
}
.ibox-title {
  color: inherit;
  margin-bottom: 0;
  padding: 1rem;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  width: unset !important;
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
  float: none;
}
.graphminheight {
  min-height: 310px;
}
.graphminheight2 {
  min-height: 420px;
}
/* KPI */
.card {
  background: #fff;
  padding: 20px;
  margin-bottom: 25px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}
.kpi-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}
.kpi {
  padding: 15px;
  border-radius: 10px;
}
.kpi h3 {
  margin: 0;
  font-size: 14px;
  color: #555;
}
.kpi p {
  margin: 5px 0 0;
  font-size: 22px;
  font-weight: bold;
}

/* filters */
.filters {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

/* loader */
.chart-loader {
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loader-text {
  margin-top: 8px;
  font-size: 12px;
  opacity: 0.8;
}
</style>
